import { baseApi } from 'services';

export type TSeason = {
  id: number;
  name: string;
};

type TGetAllPayload = {
  archived?: number;
  id?: number;
  projectId?: number;
  parentId?: number;
  type?: string;
};

export const seasonsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSeasons: builder.query<TSeason[], TGetAllPayload>({
      query: (body) => ({
        url: 'common/seasons/get-all',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetSeasonsQuery } = seasonsApi;
